var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showIf)?_c('div',{staticClass:"flex flex-row flex-wrap"},_vm._l((_vm.items),function(item,i){return _c('div',{key:i,staticClass:"mr-1 text-lg",class:_vm.makeClass(i),on:{"click":function($event){item.meta.canSwitchOrg ? _vm.handleOrgSwitch(item.org) : null}}},[_vm._v(" "+_vm._s(_vm.itemText(item, i))+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }